import { createFeatureSelector, createSelector } from '@ngrx/store';
import { bookmarkProblemsFeatureKey, State } from '../reducers/bookmark-problems.reducer';

const selectBookmarkProblemsState = createFeatureSelector<State>(bookmarkProblemsFeatureKey);

export const getBookmarkProblems = createSelector(selectBookmarkProblemsState, state => state.bookmarkProblems);
export const getBookmarkProblemToDelete = createSelector(selectBookmarkProblemsState, state => state.bookmarkProblemToDelete);
